import React from 'react';

const styles: Record<string, React.CSSProperties> = {
  paper: {
    marginTop: 24,
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto',
    padding: 10,
  },
  topRow: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 24,
  },
  fieldsContainer: {display: 'flex', flexWrap: 'wrap', gap: '5%'},
};

export default styles;
